<template>
  <div class="mandanten_app">
    <div v-if="show_pdf">
      <div style="width:100%;">
        <img class="iframebacklogo" src="static/img/logo.svg"/> 
        <button class="iframebackbutton" @click="call_restore_after_show_pdf()">&laquo; App</button>
      </div>
      <div style="width:100%;">
        <iframe :src="'static/pdf/viewer.html?file=' + encodeURI(show_pdf)" class="fullscreen_iframe_tag" style="width:100%;" frameborder="0" :style="platform_dependent_css_height_style"></iframe>
      </div>
    </div>
    <div v-if="show_image">
      <div style="width:100%;">
        <img class="iframebacklogo" src="static/img/logo.svg"/> 
        <button class="iframebackbutton" @click="call_restore_after_show_image()">&laquo; App</button>
        <button :class="{'ausgegraut': !vorheriges_bild}" class="iframebackbutton" @click="zeige_vorheriges_bild">&laquo; </button>
        <button :class="{'ausgegraut': !naechstes_bild}" class="iframebackbutton" @click="zeige_naechstes_bild">&raquo; </button>
      </div>
      <div style="width:100%;">
        <img :src="show_image" class="fullscreen_image_tag" :style="platform_dependent_css_max_height_style"/>
      </div>
    </div>
    <div v-show="!show_pdf && !show_image">
      <header id="header">
        <div class="iphonetopline"></div>
        <div class="container-fluid">
          <router-link class="headerlogolink" to="/">
              <strong class="logo"></strong>
          </router-link>
          <div class="fader"></div>
          <a @click="mobilemenuetoggle" class="btn-menu" style="display:block;">
            <span></span>
            <span></span>
            <span></span>
          </a>
        </div>
        <div v-if="mobilemenue" class="row" @click="mobilemenue = false">
          <router-link to="/vertraege" class="mobilemenuelink"><i class="fa-duotone fa-file-signature"></i><span class="menutext">Verträge</span></router-link>
          <router-link to="/nachrichten" class="mobilemenuelink"><i class="fa-solid fa-message-captions"></i><span class="anzahl_neue_nachrichten_menue" v-if="anzahl_neue_nachrichten > 0">{{anzahl_neue_nachrichten}}</span><span class="menutext">Nachrichten</span></router-link>
          <router-link to="/empfehlungen" class="mobilemenuelink"><i class="fa-duotone fa-address-card"></i><span class="menutext">Empfehlungen</span></router-link>
          <router-link to="/profil" class="mobilemenuelink"><i class="fa-duotone fa-ballot-check"></i><span class="menutext">Meine Daten</span></router-link>
          <router-link to="/kontakt" class="mobilemenuelink"><i class="fa-duotone fa-messages"></i><span class="menutext">Kontakt</span></router-link>
          <div v-if="is_android()" class="mobilemenuelink show_only_in_android" @click="appExitOnAndroid"><i class="fa-duotone fa-power-off"></i><span class="menutext">Schliessen</span></div>
          <a href="#" @click="logout" class="mobilemenuelink"><i class="fa-duotone fa-arrow-right-from-bracket"></i><span class="menutext">Abmelden</span></a>
        </div>
      </header>

      <div id="mandanten_app_content_id" class="mandanten_app_content" v-show="!mobilemenue">
        <div v-if="!mandanten_id || $route.name === 'Login'">
          <div v-if="warte_auf_login">
            Sie werden angemeldet..
          </div>
          <div v-if="!warte_auf_login">
            <div v-if="login_fehlermeldung" class="login_fehlermeldung">
              {{login_fehlermeldung}}
            </div>
            <b>Bitte melden Sie sich an:</b><br/>
            <br/>
            <form v-on:submit.prevent="login">
              <span>Benutzername</span><br/>
              <input type="text" ref="benutzername" class="form-control m-b" name="loginname" v-model="loginname" placeholder="Benutzername"> <br/>
              <span>Passwort</span><br/>
              <input type="password" class="form-control m-b" name="password" v-model="password" placeholder="Passwort"> <br/>
              <button class="loginbutton">Login</button>
            </form>

            <div class="appstore-icons-div">
              <a href="https://play.google.com/store/apps/details?id=de.aktivforum.mandantenapp&hl=de" target="_blank"><img class="appstore-icon" src="static/img/playstore.png"/></a>
              <a href="https://apps.apple.com/de/app/aktiv-forum/id1635340467" target="_blank"><img class="appstore-icon" src="static/img/download-on-the-app-store.svg"/></a>
            </div>

          </div>
        </div>
        <div v-else>
          <div v-if="$route.name === 'Startseite'">
            <p>Sie sind angemeldet als: <b>{{mandant.mandant_anrede}} {{mandant.mandant_vorname}} {{mandant.mandant_nachname}}</b></p>
          </div>

          <div v-if="$route.name === 'Nachrichten'">
            <ul class="nachrichten dokumente_ul">
              <li v-for="nachricht in nachrichten" :key="nachricht.id">
                <span v-if="!nachricht.gelesen_datetime" class="neue_nachricht">NEU</span>
                <b>{{nachricht.app_nachricht.title}}</b><br/>
                <i>Nachricht vom {{nachricht.datum}}</i><br/>
                <a v-for="at in nachricht.app_nachricht.attachments" class="linktofile" @click="call_show_pdf(base_url + at.download_path + '?token_sha256=' + secret_token_sha256); nachricht.gelesen_datetime = new Date()" :key="at.id">{{remove_pdf_ending(at.filename)}}<br/></a>
              </li>
            </ul>
          </div>

          <div v-if="$route.name === 'Empfehlungen'">
            <h2>Empfehlungen</h2>
            <div v-if="!empfehlunganfrageabgeschickt">
              <b>Teilen Sie uns Ihren Geheimtipp mit!</b><br/>
              <i>* Bei einer Empfehlung werden alle Daten verschlüsselt übertragen. Die Daten werden gespeichert um Ihre Anfrage zu bearbeiten.</i>
              <form class="kontaktformular">
                <textarea v-model="empfehlunganfragetext"></textarea>
                <input v-if="!empfehlunganfragewirdabgeschickt" @click="sende_empfehlunganfrage" type="submit" value="Empfehlung jetzt abschicken"/>
                <i v-if="empfehlunganfragewirdabgeschickt">Anfrage wird gesendet..</i>
              </form>
            </div>
            <div v-if="empfehlunganfrageabgeschickt">
              <h2>Vielen Dank für Ihre Empfehlung</h2>
              <pre>
{{empfehlunganfragetext}}
              </pre>
              <b style="color:#007dc5;">Ihre Empfehlung ist am {{formatDateForHTML(empfehlunganfrageabgeschickt)}} um {{formatTimeForHTML(empfehlunganfrageabgeschickt)}} Uhr bei uns eingegangen. Vielen Dank!<br/></b>
              <br/>
              <button @click="init_empfehlunganfragetext(); empfehlunganfrageabgeschickt = false;" class="loginbutton">Weitere Empfehlung &raquo;</button>
            </div>
            <br/>
            <div>
              <span class="copy">© Copyright 2010 - {{(new Date()).getFullYear()}} Rechte vorbehalten.</span>    
            </div>
          </div>

          <div v-if="$route.name === 'Kontakt'">
            <h2>Kontakt</h2>
            <div>
            <h3>aktiv forum Finanzservice GmbH &amp; Co. KG</h3>
            Senefelderstraße 15<br/>
            86368 Gersthofen
            </div>
            <div>
              Telefon: <a href="tel:08212527570">0821 - 252757-0</a>    <br/>
              Fax: <a href="tel:082125275720">0821 - 252757-20</a>    <br/>
              eMail: <a href="mailto:info@aktiv-forum.de">info@aktiv-forum.de</a>
            </div>
            <br/>
            <div v-if="!kontaktanfrageabgeschickt">
              <h2>Sie haben eine Frage?</h2>
              <i>* Bei einer Kontaktanfrage werden alle Daten verschlüsselt übertragen. Die Daten werden gespeichert um Ihre Anfrage zu bearbeiten.</i>
              <form class="kontaktformular">
                <textarea v-model="kontaktanfragetext"></textarea>
                <input v-if="!kontaktanfragewirdabgeschickt" @click="sende_kontaktanfrage" type="submit" value="Anfrage jetzt abschicken"/>
                <i v-if="kontaktanfragewirdabgeschickt">Anfrage wird gesendet..</i>
              </form>
            </div>
            <div v-if="kontaktanfrageabgeschickt">
              <h2>Vielen Dank für Ihre Nachricht</h2>
              <pre>
{{kontaktanfragetext}}
              </pre>
              <b style="color:#007dc5;">Ihre Anfrage ist am {{formatDateForHTML(kontaktanfrageabgeschickt)}} um {{formatTimeForHTML(kontaktanfrageabgeschickt)}} Uhr bei uns eingegangen. Bitte geben sie uns 2-3 Arbeitstage um Ihr Anliegen zu bearbeiten.<br/></b>
              <br/>
              <button @click="init_kontaktanfragetext(); kontaktanfrageabgeschickt = false;" class="loginbutton">Neue Kontaktanfrage &raquo;</button>
            </div>
            <br/>
            <div>
              <span class="copy">© Copyright 2010 - {{(new Date()).getFullYear()}} Rechte vorbehalten.</span>    
            </div>
          </div>

          <div v-if="$route.name === 'Profil'">
            <h2>Meine Daten</h2>
            <div class="profil">
              <div v-if="mandant.mandant_nachname" class="tab_content" style="margin-bottom:10px;">
                <h3>Mandant</h3>
                <div class="row" v-if="mandant.mandant_vorname"><div class="stammdatum col-4 ">Vorname</div><div class="stammdatum_value col-8">{{mandant.mandant_vorname}}</div></div>
                <div class="row" v-if="mandant.mandant_nachname"><div class="stammdatum col-4">Nachname</div><div class="stammdatum_value col-8 ">{{mandant.mandant_nachname}}</div></div>
                <div class="row" v-if="mandant.mandant_anrede"><div class="stammdatum col-4">Anrede</div><div class="stammdatum_value col-8 ">{{mandant.mandant_anrede}}</div></div>
                <div class="row" v-if="mandant.mandant_strasse"><div class="stammdatum col-4">Strasse</div><div class="stammdatum_value col-8 ">{{mandant.mandant_strasse}}</div></div>
                <div class="row" v-if="mandant.mandant_hausnummer"><div class="stammdatum col-4">Hausnummer</div><div class="stammdatum_value col-8 ">{{mandant.mandant_hausnummer}}</div></div>
                <div class="row" v-if="mandant.mandant_plz"><div class="stammdatum col-4">PLZ</div><div class="stammdatum_value col-8 ">{{mandant.mandant_plz}}</div></div>
                <div class="row" v-if="mandant.mandant_ort"><div class="stammdatum col-4">Wohnort</div><div class="stammdatum_value col-8 ">{{mandant.mandant_ort}}</div></div>
                <div class="row" v-if="mandant.mandant_geburtsname"><div class="stammdatum col-4">Geburtsname</div><div class="stammdatum_value col-8 ">{{mandant.mandant_geburtsname}}</div></div>
                <div class="row" v-if="mandant.mandant_geburtsdatum"><div class="stammdatum col-4">Geburtsdatum</div><div class="stammdatum_value col-8 ">{{formatDateForHTML(mandant.mandant_geburtsdatum)}}</div></div>
                <h4>Kontakt</h4>
                <div class="row" v-if="mandant.mandant_telefon"><div class="stammdatum col-4">Telefon</div><div class="stammdatum_value col-8 ">{{mandant.mandant_telefon}}</div></div>
                <div class="row" v-if="mandant.mandant_handy"><div class="stammdatum col-4">Handy</div><div class="stammdatum_value col-8 ">{{mandant.mandant_handy}}</div></div>
                <div class="row" v-if="mandant.mandant_telefon_geschaeftlich"><div class="stammdatum col-4">Telefon geschäftlich</div><div class="stammdatum_value col-8 ">{{mandant.mandant_telefon_geschaeftlich}}</div></div>
                <div class="row" v-if="mandant.mandant_email"><div class="stammdatum col-4">E-Mail</div><div class="stammdatum_value col-8 ">{{mandant.mandant_email}}</div></div>

                <div v-if="mandant.mandant_bankinstitut">
                  <h4>Bankverbindung</h4>
                  <div class="row" v-if="mandant.mandant_bankinstitut"><div class="stammdatum col-4">Bankinstitut</div><div class="stammdatum_value col-8 ">{{mandant.mandant_bankinstitut}}</div></div>
                  <div class="row" v-if="mandant.mandant_kontoinhaber"><div class="stammdatum col-4">Kontoinhaber</div><div class="stammdatum_value col-8 ">{{mandant.mandant_kontoinhaber}}</div></div>
                  <div class="row" v-if="mandant.mandant_iban"><div class="stammdatum col-4">IBAN</div><div class="stammdatum_value col-8 ">{{mandant.mandant_iban}}</div></div>
                  <div class="row" v-if="mandant.mandant_bic"><div class="stammdatum col-4">BIC</div><div class="stammdatum_value col-8 ">{{mandant.mandant_bic}}</div></div>
                </div>

                <div v-if="mandant.mandant_steuernummer || mandant.mandant_steuer_id_nr">
                  <h4>Steuer</h4>
                  <div class="row" v-if="mandant.mandant_steuernummer"><div class="stammdatum col-4">Steuernummer</div><div class="stammdatum_value col-8 ">{{mandant.mandant_steuernummer}}</div></div>
                  <div class="row" v-if="mandant.mandant_steuer_id_nr"><div class="stammdatum col-4">Steuer-ID Nr</div><div class="stammdatum_value col-8 ">{{mandant.mandant_steuer_id_nr}}</div></div>
                </div>
              </div>
              <div v-if="mandant.partner_nachname" class="tab_content" style="margin-bottom:10px;">
                <h3>Partner</h3>
                <div class="row" v-if="mandant.partner_vorname"><div class="stammdatum col-4">Vorname</div><div class="stammdatum_value col-8 ">{{mandant.partner_vorname}}</div></div>
                <div class="row" v-if="mandant.partner_nachname"><div class="stammdatum col-4">Nachname</div><div class="stammdatum_value col-8 ">{{mandant.partner_nachname}}</div></div>
                <div class="row" v-if="mandant.partner_anrede"><div class="stammdatum col-4">Anrede</div><div class="stammdatum_value col-8 ">{{mandant.partner_anrede}}</div></div>
                <div class="row" v-if="mandant.partner_strasse"><div class="stammdatum col-4">Strasse</div><div class="stammdatum_value col-8 ">{{mandant.partner_strasse}}</div></div>
                <div class="row" v-if="mandant.partner_hausnummer"><div class="stammdatum col-4">Hausnummer</div><div class="stammdatum_value col-8 ">{{mandant.partner_hausnummer}}</div></div>
                <div class="row" v-if="mandant.partner_plz"><div class="stammdatum col-4">PLZ</div><div class="stammdatum_value col-8 ">{{mandant.partner_plz}}</div></div>
                <div class="row" v-if="mandant.partner_ort"><div class="stammdatum col-4">Ort</div><div class="stammdatum_value col-8 ">{{mandant.partner_ort}}</div></div>
                <div class="row" v-if="mandant.partner_geburtsdatum"><div class="stammdatum col-4">Geburtsdatum</div><div class="stammdatum_value col-8 ">{{formatDateForHTML(mandant.partner_geburtsdatum)}}</div></div>
                <div class="row" v-if="mandant.partner_geburtsname"><div class="stammdatum col-4">partner_geburtsname</div><div class="stammdatum_value col-8 ">{{mandant.partner_geburtsname}}</div></div>

                <div v-if="mandant.partner_telefon || mandant.partner_handy || mandant.partner_telefon_geschaeftlich || mandant.partner_email">
                  <h4>Kontakt</h4>
                  <div class="row" v-if="mandant.partner_telefon"><div class="stammdatum col-4">Telefon</div><div class="stammdatum_value col-8 ">{{mandant.partner_telefon}}</div></div>
                  <div class="row" v-if="mandant.partner_handy"><div class="stammdatum col-4">Handy</div><div class="stammdatum_value col-8 ">{{mandant.partner_handy}}</div></div>
                  <div class="row" v-if="mandant.partner_telefon_geschaeftlich"><div class="stammdatum col-4">Telefon geschäftlich</div><div class="stammdatum_value col-8 ">{{mandant.partner_telefon_geschaeftlich}}</div></div>
                  <div class="row" v-if="mandant.partner_email"><div class="stammdatum col-4">E-Mail</div><div class="stammdatum_value col-8 ">{{mandant.partner_email}}</div></div>
                </div>

                <div v-if="mandant.partner_bankinstitut">
                  <h4>Bankverbindung</h4>
                  <div class="row" v-if="mandant.partner_bankinstitut"><div class="stammdatum col-4">partner_bankinstitut</div><div class="stammdatum_value col-8 ">{{mandant.partner_bankinstitut}}</div></div>
                  <div class="row" v-if="mandant.partner_kontoinhaber"><div class="stammdatum col-4">partner_kontoinhaber</div><div class="stammdatum_value col-8 ">{{mandant.partner_kontoinhaber}}</div></div>
                  <div class="row" v-if="mandant.partner_iban"><div class="stammdatum col-4">partner_iban</div><div class="stammdatum_value col-8 ">{{mandant.partner_iban}}</div></div>
                  <div class="row" v-if="mandant.partner_bic"><div class="stammdatum col-4">partner_bic</div><div class="stammdatum_value col-8 ">{{mandant.partner_bic}}</div></div>
                </div>

                <div v-if="mandant.partner_steuernummer || mandant.partner_steuer_id_nr">
                  <h4>Steuer</h4>
                  <div class="row" v-if="mandant.partner_steuernummer"><div class="stammdatum col-4">Steuernummer</div><div class="stammdatum_value col-8 ">{{mandant.partner_steuernummer}}</div></div>
                  <div class="row" v-if="mandant.partner_steuer_id_nr"><div class="stammdatum col-4">Steuer-ID Nr</div><div class="stammdatum_value col-8 ">{{mandant.partner_steuer_id_nr}}</div></div>
                </div>
              </div>
              <div v-if="mandant.kind1_nachname" class="tab_content" style="margin-bottom:10px;">
                <h3>Kind</h3>
                <div class="row" v-if="mandant.kind1_vorname"><div class="stammdatum col-4">Vorname</div><div class="stammdatum_value col-8 ">{{mandant.kind1_vorname}}</div></div>
                <div class="row" v-if="mandant.kind1_nachname"><div class="stammdatum col-4">Nachname</div><div class="stammdatum_value col-8 ">{{mandant.kind1_nachname}}</div></div>
                <div class="row" v-if="mandant.kind1_geburtsdatum"><div class="stammdatum col-4">Geburtsdatum</div><div class="stammdatum_value col-8 ">{{formatDateForHTML(mandant.kind1_geburtsdatum)}}</div></div>
                <div class="row" v-if="mandant.kind1_taetigkeit"><div class="stammdatum col-4">Tätigkeit</div><div class="stammdatum_value col-8 ">{{mandant.kind1_taetigkeit}}</div></div>
              </div>
              <div v-if="mandant.kind2_nachname" class="tab_content" style="margin-bottom:10px;">
                <h3>Kind</h3>
                <div class="row" v-if="mandant.kind2_vorname"><div class="stammdatum col-4">Vorname</div><div class="stammdatum_value col-8 ">{{mandant.kind2_vorname}}</div></div>
                <div class="row" v-if="mandant.kind2_nachname"><div class="stammdatum col-4">Nachname</div><div class="stammdatum_value col-8 ">{{mandant.kind2_nachname}}</div></div>
                <div class="row" v-if="mandant.kind2_geburtsdatum"><div class="stammdatum col-4">Geburtsdatum</div><div class="stammdatum_value col-8 ">{{formatDateForHTML(mandant.kind2_geburtsdatum)}}</div></div>
                <div class="row" v-if="mandant.kind2_taetigkeit"><div class="stammdatum col-4">Tätigkeit</div><div class="stammdatum_value col-8 ">{{mandant.kind2_taetigkeit}}</div></div>
              </div>
              <div v-if="mandant.kind3_nachname" class="tab_content" style="margin-bottom:10px;">
                <h3>Kind</h3>
                <div class="row" v-if="mandant.kind3_vorname"><div class="stammdatum col-4">Vorname</div><div class="stammdatum_value col-8 ">{{mandant.kind3_vorname}}</div></div>
                <div class="row" v-if="mandant.kind3_nachname"><div class="stammdatum col-4">Nachname</div><div class="stammdatum_value col-8 ">{{mandant.kind3_nachname}}</div></div>
                <div class="row" v-if="mandant.kind3_geburtsdatum"><div class="stammdatum col-4">Geburtsdatum</div><div class="stammdatum_value col-8 ">{{formatDateForHTML(mandant.kind3_geburtsdatum)}}</div></div>
                <div class="row" v-if="mandant.kind3_taetigkeit"><div class="stammdatum col-4">Tätigkeit</div><div class="stammdatum_value col-8 ">{{mandant.kind3_taetigkeit}}</div></div>
              </div>
              <div v-if="mandant.kind4_nachname" class="tab_content" style="margin-bottom:10px;">
                <h3>Kind</h3>
                <div class="row" v-if="mandant.kind4_vorname"><div class="stammdatum">Vorname</div><div class="stammdatum_value col-4 ">{{mandant.kind4_vorname}}</div></div>
                <div class="row" v-if="mandant.kind4_nachname"><div class="stammdatum col-8">Nachname</div><div class="stammdatum_value col-4 ">{{mandant.kind4_nachname}}</div></div>
                <div class="row" v-if="mandant.kind4_geburtsdatum"><div class="stammdatum col-8">Geburtsdatum</div><div class="stammdatum_value col-4 ">{{formatDateForHTML(mandant.kind4_geburtsdatum)}}</div></div>
                <div class="row" v-if="mandant.kind4_taetigkeit"><div class="stammdatum col-8">Tätigkeit</div><div class="stammdatum_value col-4 ">{{mandant.kind4_taetigkeit}}</div></div>
              </div>
              <div v-if="mandant.kind5_nachname" class="tab_content" style="margin-bottom:10px;">
                <h3>Kind</h3>
                <div class="row" v-if="mandant.kind5_vorname"><div class="stammdatum col-8">Vorname</div><div class="stammdatum_value col-4 ">{{mandant.kind5_vorname}}</div></div>
                <div class="row" v-if="mandant.kind5_nachname"><div class="stammdatum col-8">Nachname</div><div class="stammdatum_value col-4 ">{{mandant.kind5_nachname}}</div></div>
                <div class="row" v-if="mandant.kind5_geburtsdatum"><div class="stammdatum col-8">Geburtsdatum</div><div class="stammdatum_value col-4 ">{{formatDateForHTML(mandant.kind5_geburtsdatum)}}</div></div>
                <div class="row" v-if="mandant.kind5_taetigkeit"><div class="stammdatum col-8">Tätigkeit</div><div class="stammdatum_value ">{{mandant.kind5_taetigkeit}}</div></div>
              </div>
            </div>
            <br/>
            <br/>
            <div class="abmelden" v-if="mandanten_id"><a href="#" @click="logout" class="btn"><i class="fa-duotone fa-arrow-right-from-bracket"></i> Abmelden und Logindaten löschen</a><br/>
            <br/>
            <i class="hinweis">* Beim nächsten Start der App benötigen sie Ihre Zugangsdaten um sich anzumelden.</i></div>
            <br/>
          </div>
          <div v-if="$route.name === 'Verträge'">
            <template v-if="immobilien && immobilien.length > 0">
              <h2>Immobilien</h2>
              <ul class="vertraege_ul">
                <li v-for="vertrag_id in immobilien" :key="vertrag_id" class="vertrag_li">
                  <router-link :to="'/vertrag/' + vertrag_id">
                    <vertrag-banner :vertrag="vertraege[vertrag_id]" :base_url="base_url"/>
                  </router-link>
                </li>
              </ul>
            </template>
            <template v-if="sparvertraege && sparvertraege.length > 0">
              <h2>Sparverträge</h2>
              <ul class="vertraege_ul">
                <li v-for="vertrag_id in sparvertraege" :key="vertrag_id" class="vertrag_li">
                  <router-link :to="'/vertrag/' + vertrag_id">
                    <vertrag-banner :vertrag="vertraege[vertrag_id]" :base_url="base_url"/>
                  </router-link>
                </li>
              </ul>
            </template>
            <template v-if="versicherungen && versicherungen.length > 0">
              <h2>Versicherungen</h2>
              <ul class="vertraege_ul">
                <li v-for="vertrag_id in versicherungen" :key="vertrag_id" class="vertrag_li">
                  <router-link :to="'/vertrag/' + vertrag_id">
                    <vertrag-banner :vertrag="vertraege[vertrag_id]" :base_url="base_url"/>
                  </router-link>
                </li>
              </ul>
            </template>
          </div>

          <div v-if="$route.name === 'Anlage-V'">
            <div v-if="vertrag" class="vertrag_details_div">
              <h1>Anlage-V für Veranlagungsjahr {{$route.params.jahr}}</h1>
              <ul class="vertraege_ul">
                <li class="vertrag_li">
                  <router-link :to="'/vertrag/' + vertrag.vertrag_id">
                    <vertrag-banner :vertrag="vertraege[vertrag.vertrag_id]" :base_url="base_url"/>
                  </router-link>
                </li>
              </ul>
              <div class="row" v-if="parseInt($route.params.jahr) === anlage_v_jahre[0] && (!anlage_v_antraege_by_vertrag_und_jahr[vertrag.vertrag_id] || !anlage_v_antraege_by_vertrag_und_jahr[vertrag.vertrag_id][$route.params.jahr])">
                <div style="padding:10px;text-align:justify;">
                  Bitte laden Sie alle Dokumente einzelnd oder gesammelt als PDF oder Bild der Reihe nach hoch.
                  <span><br/>Bis einschliesslich dem ersten Vermietungsjahr übernimmt aktiv forum für Sie die Kosten. Danach bekommen Sie von uns ein Angebot.</span>
                </div>
                  <ul class="benoetigte_dokumente_ul">
                    <li v-for="(b, index) in anlage_v_bezeichnungen_for_year($route.params.jahr)" :key="index" class="benoetigte_dokumente_li">
                      <div v-if="suche_vorhandene_dokumente_nach_bezeichnung(b.bezeichnung, $route.params.jahr).length > 0">
                        <div v-for="(dokument, index2) in suche_vorhandene_dokumente_nach_bezeichnung(b.bezeichnung, $route.params.jahr)" :key="dokument.url" class="dokument">
                          <span v-if="index2 === 0" class="dokumenten_bezeichnung"><br/>{{b.bezeichnung}}:<br/><br/></span>
                          <div class="dokument_hochgeladen_ok">
                            <span class="ok_badge"><i class="fa fa-check"></i></span>
                            <a v-if="dokument.download_path.match(/\.pdf$/i)" class="linktofile" @click="call_show_pdf(base_url + dokument.download_path)">{{remove_pdf_ending(dokument.filename)}}</a>
                            <a v-if="!dokument.download_path.match(/\.pdf$/i)" class="linktofile" @click="zeige_bild(base_url + dokument.download_path, true)">{{dokument.filename}}</a>
                            <a v-if="dokument.upload_von_mandant" @click="delete_upload(dokument)" class="delete_upload"><i class="fa fa-trash"></i> Datei Löschen</a>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <span class="dokumenten_bezeichnung"><br/>{{b.bezeichnung}}:</span><br/>
                        <i class="bitte_noch_hochladen"> bitte Hochladen</i>
                        <div class="hilfetext" v-if="b.hilfetext && b.hilfetext !== ''">
                          <i>{{b.hilfetext}}</i>
                        </div>
                      </div>
                      <br/>
                      <div v-if="!warte_auf_upload">
                        <div @click="upload_button_pressed(b)" class="loginbutton upload_button upload_button_datei"><i class="fa fa-upload"></i> Datei <span class="hidden-xs">hochladen</span></div>

                         <div class="upload_file_input loginbutton upload_button upload_button_foto">
                           <label for="file_input_id2" class="file_input_class">
                             <i class="fa-solid fa-camera"></i> Foto <span class="hidden-xs">hochladen</span>
                           </label>
                           <input @change="datei_ausgewaehlt" class="file_input_to_hide" id="file_input_id2" name="file2" type="file" size="50" accept="image/*;capture=camera" capture="camera"><br/>
                         </div>
                      </div>
                      <div v-if="warte_auf_upload">
                        Datei wird hochgeladen..
                      </div>
                      <div style="clear:both;"></div>
                    </li>
                    <li class="benoetigte_dokumente_li">
                      <div v-for="dokument in immobilen_anhaenge_fuer_anlage_v" :key="dokument.id">
                        <div class="dokument">
                          <div class="dokument_hochgeladen_ok">
                            <span class="dokumenten_bezeichnung"><br/>{{dokument.title}}:<br/><br/></span>
                              <span class="ok_badge"><i class="fa fa-check"></i></span>
                              <a v-if="dokument.url.match(/\.pdf$/i)" class="linktofile" @click="call_show_pdf(base_url + dokument.url)">PDF Anzeigen</a>
                              <a v-if="!dokument.url.match(/\.pdf$/i)" class="linktofile" @click="zeige_bild(base_url + dokument.url, true)">Bild Anzeigen</a>

                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <br/>

                    <form v-if="render_uploadform" style="display:none;" id="upload_form" action="" method="post" enctype="multipart/form-data">
                      <select v-model="dokumenten_bezeichnung_id">
                        <option :value="parseInt(b.id)" v-for="(b, index) in anlage_v_bezeichnungen_for_year($route.params.jahr)" :key="index">
                        {{b.bezeichnung}}
                        </option>
                      </select>
                      <div class="upload_file_input">
                        <label for="file_input_id" class="file_input_class">
                          <img src="static/img/pdf-icon.png" class="upload_file_img"/> <span class="trl">PDF</span>
                        </label>
                        <input @change="datei_ausgewaehlt" class="file_input_to_hide" id="file_input_id" name="file" type="file" size="50" accept="application/pdf;image/*"><br/>
                      </div>
                    </form>
                  <h2>Anlage-V beantragen</h2>
                  <div v-if="anlage_v_wurde_beantragt === vertrag.vertrag_id + ':' + $route.params.jahr" class="anlage_v_wurde_beantragt">
                    <b>Die Anlage-V wurde beantragt. Ein Mitarbeiter wird sich in kürze bei Ihnen melden</b>
                  </div>
                  <div v-if="anlage_v_wurde_beantragt !== (vertrag.vertrag_id + ':' + $route.params.jahr)" class="anlage_v_wurde_noch_nicht_beantragt">
                    <div v-if="!alle_erforderlichen_dokumente_vorhanden" class="anlage_v_noch_nicht_alle_dokumente_vorhanden">
                      <i>* Es wurden noch nicht alle benötigten Dokumente hochgeladen.</i>
                    </div>
                    <div v-if="alle_erforderlichen_dokumente_vorhanden" class="anlage_v_alle_dokumente_vorhanden">
                      Es wurden alle benötigten Dokumente hochgeladen. Sie können jetzt die Erstellung der Anlage-V für das Veranlagungsjahr {{$route.params.jahr}} beauftragen.<br/><br/>
                      Bitte prüfen Sie vorher nochmals ob auch alle Rechnungen hochgeladen wurden, da wir nicht wissen können wieviele Rechnungen Sie haben. Sollten Sie sich bei einer Rechnung nicht sicher sein, so laden Sie diese bitte unbedingt hoch, unser Steuerberater wird das für sie prüfen.<br/><br/>
                      Bitte beachten Sie, dass wir von Ihnen nicht eingereichte Belege bei der Erstellung der Anlage V im Nachhinein leider nicht berücksichtigen können.<br/><br/>

                      <button @click="beantrage_anlage_v" class="loginbutton">Jetzt Anlage-V mit den bereitgestellten Dokumenten beantragen &raquo;</button>
                    </div>
                  </div>
              </div>
              <div class="row" v-if="parseInt($route.params.jahr) !== anlage_v_jahre[0] || (anlage_v_antraege_by_vertrag_und_jahr[vertrag.vertrag_id] && anlage_v_antraege_by_vertrag_und_jahr[vertrag.vertrag_id][$route.params.jahr])">
                <div class="col-12">
                  <b>Dokumente für die Anlage V im Jahr {{$route.params.jahr}}:</b>
                  <span v-if="anlage_v_antraege_by_vertrag_und_jahr[vertrag.vertrag_id] && anlage_v_antraege_by_vertrag_und_jahr[vertrag.vertrag_id][$route.params.jahr]">
                    (beantragt {{formatDateForHTML(new Date(Date.parse(anlage_v_antraege_by_vertrag_und_jahr[vertrag.vertrag_id][$route.params.jahr])))}})
                  </span>
                  <br/>
                  <br/>
                  <ul class="benoetigte_dokumente_ul">
                    <li v-for="(b, index) in anlage_v_bezeichnungen_for_year($route.params.jahr)" :key="index" class="benoetigte_dokumente_li">
                      <div v-if="suche_vorhandene_dokumente_nach_bezeichnung(b.bezeichnung, $route.params.jahr).length > 0">
                        <div v-for="(dokument, index2) in suche_vorhandene_dokumente_nach_bezeichnung(b.bezeichnung, $route.params.jahr)" :key="dokument.url" class="dokument">
                          <span v-if="index2 === 0" class="dokumenten_bezeichnung"><br/>{{b.bezeichnung}}:<br/></span>
                          <span class="ok_badge"><i class="fa fa-check"></i></span> <a class="linktofile" @click="call_show_pdf(base_url + dokument.download_path)">{{remove_pdf_ending(dokument.filename)}}</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div v-if="$route.name === 'Vertrag'">
            <div v-if="vertrag" class="vertrag_details_div">
              <ul class="vertraege_ul">
                <li class="vertrag_li">
                  <a>
                    <vertrag-banner :vertrag="vertrag" :base_url="base_url"/>
                  </a>
                </li>
              </ul>
              <div class="row" v-if="vertrag.product && vertrag.product !== 'Immobilie'">
                <div class="tabs">
                  <div class="tab tab_auvesta" :class="{active: aktuelles_tab === false}" @click="aktuelles_tab = false"><i class="fa-duotone fa-file-contract"></i> Vertragsdaten</div>
                  <div v-if="dokumente(false).length > 0" class="tab tab_auvesta" :class="{active: aktuelles_tab === 'dokumente'}" @click="aktuelles_tab = 'dokumente'"><i class="fa-duotone fa-files"></i> Dokumente</div>
                </div>
                <br/>
              </div>
              <div v-if="vertrag.product === 'Immobilie'">
                <div class="tabs">
                  <div class="tab" :class="{active: aktuelles_tab === false}" @click="aktuelles_tab = false"><i class="fa-duotone fa-house"></i> Objekt</div>
                  <div class="tab" :class="{active: aktuelles_tab === 'lage'}" @click="aktuelles_tab = 'lage'"><i class="fa-duotone fa-location-dot"></i> Lage</div>
                  <div class="tab" :class="{active: aktuelles_tab === 'bilder'}" @click="aktuelles_tab = 'bilder'"><i class="fa-duotone fa-images"></i> Bilder</div>

                  <div v-if="dokumente(false).length > 0" class="tab" :class="{active: aktuelles_tab === 'dokumente'}" @click="aktuelles_tab = 'dokumente'"><i class="fa-duotone fa-files"></i> Dokumente</div>
                  <div class="tab" :class="{active: aktuelles_tab === 'finanzierung'}" @click="aktuelles_tab = 'finanzierung'"><i class="fa-duotone fa-coins"></i> Finanzierung</div>

                  <div class="tab" :class="{active: aktuelles_tab === 'steuer'}" @click="aktuelles_tab = 'steuer'"><i class="fa-duotone fa-abacus"></i> Steuer</div>

                </div>
                <div class="tab_content" v-if="aktuelles_tab === false">
                  <div v-for="wohnung in vertrag.wohnungen" :key="wohnung.wohnung_id" class="wohnungsdaten">
                    <div v-if="grundrissbild_fuer_wohnung(wohnung)">
                      <img :src="base_url + grundrissbild_fuer_wohnung(wohnung).url"/>
                    </div>
                    <div class="row" v-if="false && vertrag.vertrag_abgeschlossen">
                      <div class="stammdatum stammdatum_objekt_bezeichnung">Datum</div>
                      <div class="stammdatum_value stammdatum_objekt_inhalt">{{formatDateForHTML(vertrag.vertrag_abgeschlossen)}}</div>
                    </div>
                    <div class="row" v-if="wohnung.immobilie.bezeichnung">
                      <div class="stammdatum stammdatum_objekt_bezeichnung">Immobilienadresse</div>
                      <div class="stammdatum_value stammdatum_objekt_inhalt">{{wohnung.immobilie.bezeichnung}}</div>
                    </div>
                    <div class="row" v-if="wohnung.nummer">
                      <div class="stammdatum stammdatum_objekt_bezeichnung">Wohnungsnummer</div>
                      <div class="stammdatum_value stammdatum_objekt_inhalt">{{wohnung.nummer}}</div>
                    </div>
                    <div class="row" v-if="wohnung.garage">
                      <div class="stammdatum stammdatum_objekt_bezeichnung">Garagennummer</div>
                      <div class="stammdatum_value stammdatum_objekt_inhalt">{{wohnung.garage}}</div>
                    </div>
                    <div class="row" v-if="wohnung.tiefgarage">
                      <div class="stammdatum stammdatum_objekt_bezeichnung">Tiefgarage</div>
                      <div class="stammdatum_value stammdatum_objekt_inhalt">{{wohnung.tiefgarage}}</div>
                    </div>
                    <div class="row" v-if="wohnung.stellplatz">
                      <div class="stammdatum stammdatum_objekt_bezeichnung">Stellplatz</div>
                      <div class="stammdatum_value stammdatum_objekt_inhalt">{{wohnung.stellplatz}}</div>
                    </div>
                    <div class="row" v-if="wohnung.wohnflaeche_in_qm">
                      <div class="stammdatum stammdatum_objekt_bezeichnung">Wohnfläche</div>
                      <div class="stammdatum_value stammdatum_objekt_inhalt">{{wohnung.wohnflaeche_in_qm}}m<sup>2</sup></div>
                    </div>
                    <div class="row" v-if="wohnung.zimmer">
                      <div class="stammdatum stammdatum_objekt_bezeichnung">Anzahl Zimmer:</div>
                      <div class="stammdatum_value stammdatum_objekt_inhalt">{{wohnung.zimmer}}</div>
                    </div>
                    <div class="row" v-if="wohnung.etage">
                      <div class="stammdatum stammdatum_objekt_bezeichnung">Etage:</div>
                      <div class="stammdatum_value stammdatum_objekt_inhalt">{{wohnung.etage}}</div>
                    </div>
                    <div class="row" v-if="wohnung.aussenbereich">
                      <div class="stammdatum stammdatum_objekt_bezeichnung">Aussenbereich</div>
                      <div class="stammdatum_value stammdatum_objekt_inhalt">{{wohnung.aussenbereich}}</div>
                    </div>

                    <div class="row" v-if="wohnung.preis_wohnung">
                      <div class="" v-if="vertrag.summe">
                        <div class="stammdatum stammdatum_objekt_bezeichnung">Gesamtkaufpreis</div>
                        <div class="stammdatum_value stammdatum_objekt_inhalt">{{format_euro(vertrag.summe)}}</div>
                      </div>
                    </div>

                    <div class="row" v-if="wohnung.preis_wohnung">
                      <div class="stammdatum stammdatum_objekt_bezeichnung">Kaufpreis Wohnung</div>
                      <div class="stammdatum_value stammdatum_objekt_inhalt">{{format_euro(wohnung.preis_wohnung)}}</div>
                    </div>
                    <div class="row" v-if="wohnung.preis_garage">
                      <div class="stammdatum stammdatum_objekt_bezeichnung">Kaufpreis Garage</div>
                      <div class="stammdatum_value stammdatum_objekt_inhalt">{{format_euro(wohnung.preis_garage)}}</div>
                    </div>
                    <div class="row" v-if="wohnung.preis_tiefgarage">
                      <div class="stammdatum stammdatum_objekt_bezeichnung">Kaufpreis Tiefgarage</div>
                      <div class="stammdatum_value stammdatum_objekt_inhalt">{{format_euro(wohnung.preis_tiefgarage)}}</div>
                    </div>
                    <div class="row" v-if="wohnung.preis_stellplatz">
                      <div class="stammdatum stammdatum_objekt_bezeichnung">Kaufpreis Stellplatz</div>
                      <div class="stammdatum_value stammdatum_objekt_inhalt">{{format_euro(wohnung.preis_stellplatz)}}</div>
                    </div>

                    <div class="row" v-if="wohnung.sonstiges">
                      <div class="stammdatum stammdatum_objekt_bezeichnung">Sonstiges</div>
                      <div class="stammdatum_value stammdatum_objekt_inhalt">{{wohnung.sonstiges}}</div>
                    </div>

                    <div class="row" v-if="wohnung.immobilie.objektbeschreibung">
                      <br/>
                      <div class="stammdatum_value normal col-12">{{wohnung.immobilie.objektbeschreibung}}</div>
                    </div>
                  </div>
                </div>
                <div class="tab_content" v-if="aktuelles_tab === 'finanzierung'">
                  <div class="row" v-if="vertrag.zusatz == 'Hausbank'">
                    <div class="stammdatum col-4">finanzierende Bank</div>
                    <div class="stammdatum_value col-8">Hausbank</div>
                  </div>

                  <div class="row" v-if="vertrag.zusatz == 'Kreissparkasse'">
                    <div class="stammdatum col-4">finanzierende Bank</div>
                    <div class="stammdatum_value col-8">
                      Sparkasse Schwaben-Bodensee<br/>
                      Geschäftsstelle Gersthofen<br/>
                      Bauernstr. 1<br/>
                      86368 Gersthofen<br/>
                      <br/>
                      Telefon 08331 609-41739<br/>
                      Ansprechpartner: Manfred Pögl<br/>
                      E-Mail: <a href="mailto:manfred.poegl@spk-sbo.de">manfred.poegl@spk-sbo.de</a><br/>
                    </div>
                  </div>

                  <div class="row" v-if="vertrag.zusatz == 'VR Bank'">
                    <div class="stammdatum col-4">finanzierende Bank</div>
                    <div class="stammdatum_value col-8">
                      VR Bank Augsburg-Ostallgäu eG<br/>
                      Schießgrabenstraße 10<br/>
                      86150 Augsburg<br/><br/>
                      Tel. 0821/50400<br/>
                      Ansprechpartner: Martin Werner<br/>
                      E-Mail: <a href="mailto:martin.werner@vr-bank-a-oal.de">martin.werner@vr-bank-a-oal.de</a>
                    </div>
                  </div>

                  <br/>
                </div>
                <div class="tab_content" v-if="aktuelles_tab === 'steuer'">
                  <h2 class="ueberschrift_kleiner">aktiv forum unterstützt Sie gerne bei der Erstellung der Anlage-V</h2>
                  <ul class="anlage_v_jahre">
                    <li v-for="(jahr, index) in anlage_v_jahre" :key="jahr">
                      <div v-if="index === 0 && (!anlage_v_antraege_by_vertrag_und_jahr[vertrag.vertrag_id] || !anlage_v_antraege_by_vertrag_und_jahr[vertrag.vertrag_id][String(jahr)])" class="aktuelles_anlage_v_jahr">
                        <b>Benötigte Dokumente für {{jahr}}:</b>
                          <ul>
                            <li v-for="b in anlage_v_bezeichnungen_for_year(jahr)" :key="b.bezeichnung + ':' + index + ':' + jahr">
                              {{b.bezeichnung}}
                            </li>
                          </ul>
                        <span v-if="index >= anlage_v_jahre.length - 2"><br/>Bis einschl. dem ersten Vermietungsjahr übernimmt aktiv forum für Sie die Kosten!</span>
                          <router-link :to="anlage_v_href(jahr)" class="loginbutton">Anlage-V Veranlagungsjahr {{jahr}} bearbeiten</router-link>
                      </div>
                      <div v-if="anlage_v_antraege_by_vertrag_und_jahr[vertrag.vertrag_id] && anlage_v_antraege_by_vertrag_und_jahr[vertrag.vertrag_id][String(jahr)]" class="ehemaliges_anlage_v_jahr">
                        <router-link :to="anlage_v_href(jahr)" class="loginbutton">Anlage-V Veranlagungsjahr {{jahr}} anzeigen (beantragt {{formatDateForHTML(new Date(Date.parse(anlage_v_antraege_by_vertrag_und_jahr[vertrag.vertrag_id][String(jahr)])))}})</router-link>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div v-if="(vertrag.product === 'Opti5' || vertrag.product === 'Multi Rente') && aktuelles_tab === false" class="tab_content">
                <div class="row">
                  <div class="stammdatum col-4">Produkt</div>
                  <div class="stammdatum_value col-8">{{vertrag.product}}</div>
                </div>
                <div class="row" v-if="vertrag.vertrag_abgeschlossen">
                  <div class="stammdatum col-4">Datum</div>
                  <div class="stammdatum_value col-8">{{formatDateForHTML(vertrag.vertrag_abgeschlossen)}}</div>
                </div>
                <div class="row" v-if="vertrag.opti5_versicherungsnummer">
                  <div class="stammdatum col-4">Versicherungsnummer</div>
                  <div class="stammdatum_value col-8">{{vertrag.opti5_versicherungsnummer}}</div>
                </div>
                <div class="row" v-if="vertrag.opti5_tarif">
                  <div class="stammdatum col-4">Tarif</div>
                  <div class="stammdatum_value col-8">{{vertrag.opti5_tarif}}</div>
                </div>
                <div class="row" v-if="vertrag.summe">
                  <div class="stammdatum col-4">Monatsrente</div>
                  <div class="stammdatum_value col-8">{{format_euro(vertrag.summe)}}</div>
                </div>
                <div class="row" v-if="vertrag.beitrag">
                  <div class="stammdatum col-4">Beitrag</div>
                  <div class="stammdatum_value col-8">{{format_euro(vertrag.beitrag)}}</div>
                </div>

                <template v-if="vertrag.product === 'Opti5'">
                  <div class="row">
                    <div class="stammdatum col-12"><h4>Flyer</h4></div>
                  </div>
                  <div class="row">
                    <div class="stammdatum col-4">Beratungsblock Opti5 Rente</div>
                    <div class="stammdatum_value col-8"><a class="linktofile" @click="call_show_pdf(base_url+ '/downloads/Beratungsblock_opti_rente_adcuri.pdf')">Beratungsblock_opti_rente_adcuri.pdf</a></div>
                  </div>

                  <div class="row">
                    <div class="stammdatum col-4">Bedingungen Opti5 Rente</div>
                    <div class="stammdatum_value col-8"><a class="linktofile" @click="call_show_pdf(base_url + '/downloads/Bedingungen-Opti5Rente.pdf')">Bedingungen-Opti5Rente.pdf</a></div>
                  </div>

                  <div class="row">
                    <div class="stammdatum col-12"><h4>Link</h4></div>
                  </div>
                  <div class="row">
                    <div class="stammdatum col-4">Adcuri-Portal</div>
                    <div class="hide_in_cordova stammdatum_value col-8"><a target="_blank" href="https://classic.adcuri.de/">https://classic.adcuri.de (blank)</a></div>
                    <div class="show_only_in_cordova stammdatum_value col-8"><a onclick="window.open('https://classic.adcuri.de/', '_system')">https://classic.adcuri.de</a></div>
                    <div v-if="false" class="show_only_in_cordova stammdatum_value col-8"><a onclick="cordova.InAppBrowser.open('https://classic.adcuri.de/', '_system','location=yes,footer=yes,footercolor=#0075bf,closebuttoncaption=Fertig')" >https://classic.adcuri.de (InAppBrowser)</a></div>
                  </div>

                  <div class="row">
                    <div class="stammdatum col-12"><h4>Kontaktdaten</h4>
                      ADCURI GmbH<br/>
                      Schloßbleiche 30<br/>
                      42103 Wuppertal<br/><br/>
                      Tel. 0202/261531-40<br/>
                      Fax: 0202/261531-42<br/><br/>
                      E-Mail: <a href="mailto:info@adcuri.com">info@adcuri.com</a>
                    </div>
                  </div>
                </template>
                <template v-if="vertrag.product === 'Multi Rente'">
                  <div class="row">
                    <div class="stammdatum col-12"><h4>Flyer</h4></div>
                  </div>
                  <div class="row">
                    <div class="stammdatum col-4">Multi Rente Erwachsene</div>
                    <div class="stammdatum_value col-8"><a class="linktofile" @click="call_show_pdf(base_url+ '/downloads/flyer_multi-rente_erwachsene_janitos_versicherung_ag.pdf')">flyer_multi-rente_erwachsene_janitos_versicherung_ag.pdf</a></div>
                  </div>

                  <div class="row">
                    <div class="stammdatum col-4">Multi Rente Kinder</div>
                    <div class="stammdatum_value col-8"><a class="linktofile" @click="call_show_pdf(base_url+ '/downloads/flyer_multi-rente_kinder_janitos_versicherung_ag.pdf')">flyer_multi-rente_kinder_janitos_versicherung_ag.pdf</a></div>
                  </div>

                  <div class="row">
                    <div class="stammdatum col-4">Versicherungsbedingungen Balance</div>
                    <div class="stammdatum_value col-8"><a class="linktofile" @click="call_show_pdf(base_url+ '/downloads/Versicherungsbedingungen Balance.pdf')">Versicherungsbedingungen Balance.pdf</a></div>
                  </div>

                  <div class="row">
                    <div class="stammdatum col-4">Versicherungsbedingungen Best Selection</div>
                    <div class="stammdatum_value col-8"><a class="linktofile" @click="call_show_pdf(base_url+ '/downloads/Versicherungsbedingungen Best Selection.pdf')">Versicherungsbedingungen Best Selection.pdf</a></div>
                  </div>

                  <div class="row">
                    <div class="stammdatum col-12"><h4>Kontaktdaten</h4>
                      Janitos Versicherung AG<br/>
                      Postfach 10 41 69<br/>
                      69031 Heidelberg<br/>
                      <br/>
                      Tel. 06221/709 1000<br/>
                      Fax: 06221/709 1001<br/>
                      <br/>
                      E-Mail: <a href="mailto:versicherung@janitos.de">versicherung@janitos.de</a>
                    </div>
                  </div>
                </template>
              </div>
              <div v-if="vertrag.product === 'Auvesta' && aktuelles_tab === false">
                <div class="tab_content">
                  <div class="row">
                    <div class="stammdatum col-4">Inhaber</div>
                    <div class="stammdatum_value col-8">{{vertrag.auvesta_im_namen_von ? vertrag.auvesta_im_namen_von : vertrag.vertrag_mit_name}}</div>
                  </div>

                  <div class="row">
                    <div class="stammdatum col-4">Produkt</div>
                    <div class="stammdatum_value col-8">{{vertrag.product}}</div>
                  </div>

                  <div class="row" v-if="vertrag.auvesta_tarif">
                    <div class="stammdatum col-4">Tarif</div>
                    <div class="stammdatum_value col-8">{{vertrag.auvesta_tarif}}</div>
                  </div>

                  <div class="row" v-if="vertrag.vertrag_abgeschlossen">
                    <div class="stammdatum col-4">Datum</div>
                    <div class="stammdatum_value col-8">{{formatDateForHTML(vertrag.vertrag_abgeschlossen)}}</div>
                  </div>

                  <div class="row" v-if="vertrag.auvesta_kundennummer">
                    <div class="stammdatum col-4">Auvesta Kundennummer</div>
                    <div class="stammdatum_value col-8">{{vertrag.auvesta_kundennummer}}</div>
                  </div>
                  <div class="row" v-if="vertrag.auvesta_depotnummer">
                    <div class="stammdatum col-4">Depotnummer</div>
                    <div class="stammdatum_value col-8">{{vertrag.auvesta_depotnummer}}</div>
                  </div>
                  <div class="row" v-if="vertrag.summe">
                    <div class="stammdatum col-4">Zielsumme</div>
                    <div class="stammdatum_value col-8">{{format_euro(vertrag.summe)}}</div>
                  </div>

                </div>
                <br/>
                <div class="tab_content">
                  <div class="row">
                    <div class="stammdatum col-12"><h4>Kontoverbindung</h4></div>
                  </div>
                  <div class="row">
                    <div class="stammdatum col-4">Empfänger</div>
                    <div class="stammdatum_value col-8">Auvesta Edelmetalle AG</div>
                  </div>
                  <div class="row">
                    <div class="stammdatum col-4">Name der Bank</div>
                    <div class="stammdatum_value col-8">Commerzbank</div>
                  </div>
                  <div class="row">
                    <div class="stammdatum col-4">IBAN</div>
                    <div class="stammdatum_value col-8">DE66 7008 0000 0402 2762 00</div>
                  </div>
                  <div class="row">
                    <div class="stammdatum col-4">BIC</div>
                    <div class="stammdatum_value col-8">DRESDEFF700</div>
                  </div>

                </div>
                <br/>
                <div class="tab_content">
                  <div class="row">
                    <div class="stammdatum col-12"><h4>Kontaktdaten</h4>
                      Auvesta Edelmetalle AG<br/>
                      Industriestr. 4<br/>
                      83607 Holzkirchen<br/><br/>
                      Tel. <a href="tel:+4980244741144">08024/4741-144</a><br/>
                      Fax: 08024/4741-146<br/><br/>
                      E-Mail: <a href="mailto:service@auvesta.com">service@auvesta.com</a>
                    </div>
                  </div>
                  <br/>
                  <div class="row">
                    <br/>
                    <div class="stammdatum col-4">Auvesta-Portal</div>
                    <div class="hide_in_cordova stammdatum_value col-8"><a class="linkbutton" style="text-align:center;" target="_blank" href="https://eservice.auvesta.com/login/login.aspx">jetzt bei Auvesta anmelden</a></div>
                    <div class="show_only_in_cordova stammdatum_value col-8"><a class="linkbutton" style="text-align:center;" onclick="window.open('https://eservice.auvesta.com/login/login.aspx', '_system')">jetzt bei Auvesta anmelden</a></div>
                    <div v-if="false" class="show_only_in_cordova stammdatum_value col-8"><a class="linkbutton" style="text-align:center;" onclick="cordova.InAppBrowser.open('https://eservice.auvesta.com/login/login.aspx', '_system','location=yes,footer=yes,footercolor=#0075bf,closebuttoncaption=Fertig')">jetzt bei Auvesta anmelden (InAppBrowser)</a></div>
                  </div>
                </div>
              </div>

              <div class="tab_content" v-if="aktuelles_tab === 'finanzierung' && dokumente(true).length > 0">
                <h3>Dokumente</h3>
                <ul class="dokumente_ul">
                  <li v-for="dokument in dokumente(true)" :key="dokument.url" class="dokument">
                    <a class="linktofile" @click="call_show_pdf(base_url + dokument.download_path)">{{remove_pdf_ending(dokument.filename)}}</a>
                  </li>
                </ul>
              </div>

              <div class="tab_content lage" v-if="aktuelles_tab === 'lage'">
                <div v-for="wohnung in vertrag.wohnungen" :key="wohnung.wohnung_id">
                  <div v-html="google_maps_url_fullwidth(wohnung.immobilie.google_maps_url)"></div>
                  <br/>
                  {{wohnung.immobilie.lage}}
                </div>
              </div>

              <div class="tab_content" v-if="aktuelles_tab === 'dokumente'">
                <ul class="dokumente_ul">
                  <li v-for="dokument in dokumente(false)" :key="dokument.url" class="dokument">
                    <a class="linktofile" @click="call_show_pdf(base_url + dokument.download_path)">{{remove_pdf_ending(dokument.filename)}}</a>
                  </li>

                  <li v-for="wohnung in vertrag.wohnungen" :key="wohnung.wohnung_id" class="dokument">
                    <div v-for="bild in wohnung.bilder" :key="bild.url">
                      <a class="linktofile" v-if="!bild.mime_type.startsWith('image/')" @click="call_show_pdf(base_url + bild.url)">
                        <span v-if="!bild.title || bild.title === ''">Dokument zu Wohnung {{wohnung.nummer}}</span>
                        <span v-if="bild.title && bild.title !== ''">{{bild.title}}</span>
                      </a>
                    </div>
                    <div v-for="bild in wohnung.immobilie.bilder" :key="bild.url">
                      <a class="linktofile" v-if="!bild.mime_type.startsWith('image/')" @click="call_show_pdf(base_url + bild.url)">
                        <span v-if="!bild.title || bild.title === ''">Dokument zu Immobilie {{wohnung.immobilie.bezeichnung}}</span>
                        <span v-if="bild.title && bild.title !== ''">{{bild.title}}</span>
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
              <ul v-if="aktuelles_tab === 'bilder'" class="bilder_ul tab_content">
                <li v-for="wohnung in vertrag.wohnungen" :key="wohnung.wohnung_id" class="bilder">
                  <div v-for="bild in bilder_fuer_wohnung_mit_mimetype_image(wohnung)" :key="bild.url" class="thumbnail">
                    <a v-if="bild.mime_type.startsWith('image/')" @click="aktuelle_wohnung = wohnung; zeige_bild(base_url + bild.url, true)"><img :src="base_url + bild.url"/></a>
                        <div v-if="bild.title && bild.title !== ''">{{bild.title}}</div>
                  </div>
                  <div v-for="bild in bilder_fuer_immobilie_mit_mimetype_image(wohnung.immobilie)" :key="bild.url" class="thumbnail">
                    <a v-if="bild.mime_type.startsWith('image/')" @click="aktuelle_wohnung = wohnung; zeige_bild(base_url + bild.url, true)"><img :src="base_url + bild.url"/></a>
                      <div v-if="bild.title && bild.title !== ''">{{bild.title}}</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <footer v-if="$route.name !== 'Login'" class="footerdiv">
        <router-link to="/vertraege" class="footerlink"><i class="fa-duotone fa-file-signature"></i><br/>Verträge</router-link>
        <router-link to="/nachrichten" class="footerlink"><span class="anzahl_neue_nachrichten_footer" v-if="anzahl_neue_nachrichten > 0">{{anzahl_neue_nachrichten}} </span><i class="fa-solid fa-message-captions"></i><br/>Nachrichten</router-link>
        <router-link to="/empfehlungen" class="footerlink"><i class="fa-duotone fa-address-card"></i><br/>Empfehlungen</router-link>
        <router-link to="/kontakt" class="footerlink"><i class="fa-duotone fa-messages"></i><br/>Kontakt</router-link>
      </footer>
    </div>
  </div>
</template>

<script>

// import * as Vue from 'vue'
import router from '@/router'
import helper from '@/helper'
import VertragBanner from '@/components/VertragBanner'

async function sha256(that, message) {
    const msgBuffer = new TextEncoder().encode(message)
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer)
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
    that.secret_token_sha256 = hashHex
}

export default {
  name: 'AppIndex',
  data: function () {
    return {
      mandanten_id: false,
      mandant: false,
      vertraege: false,
      nachrichten: false,
      loginname: '',
      password: '',
      secret_token: '',
      secret_token_sha256: '',
      base_url: 'https://kundenverwaltung.np-gruppe.de:46346/',
      ajax_url: 'https://kundenverwaltung.np-gruppe.de:46346/mandanten_app/',
      // base_url: 'https://localhost/',
      // ajax_url: 'https://localhost/mandanten_app/',
      login_fehlermeldung: false,
      warte_auf_login: false,
      warte_auf_upload: false,
      aktuelles_tab: false,
      mobilemenue: false,
      kontaktanfragetext: '',
      kontaktanfrageabgeschickt: false,
      kontaktanfragewirdabgeschickt: false,
      empfehlunganfragetext: '',
      empfehlunganfrageabgeschickt: false,
      empfehlunganfragewirdabgeschickt: false,
      anlage_v_bezeichnungen: [],
      dokumenten_bezeichnung_id: 55,
      show_pdf: false,
      show_image: false,
      last_image: false,
      anlage_v_wurde_beantragt: false,
      render_uploadform: true,
      anlage_v_antraege_by_vertrag_und_jahr: {},
      aktuelle_wohnung: false,
      fcmtokenrefreshed: false,
      last_scroll_position: 0
    }
  },
  watch: {
    $route ( to, from) {
      this.check_session()
      this.mobilemenue = false
      this.aktuelles_tab = false
      if( from.name === 'Anlage-V')
      {
        this.aktuelles_tab = 'steuer'
      }
      window.scrollTo(0, 0)
      document.getElementById('mandanten_app_content_id').scrollTo(0,0)
    }
  },
  components: {
    VertragBanner
  },
  computed: {
    platform_dependent_css_height_style () {
      let css = 'height:calc(100vh - 52px);'
      if( window.cordova && window.cordova.platformId === 'ios')
      { 
        css = 'height:calc(100vh - 132px);'
      }
      return css
    },
    platform_dependent_css_max_height_style() {
      let css = 'max-height:calc(100vh - 52px);'
      if( window.cordova && window.cordova.platformId === 'ios')
      { 
        css = 'max-height:calc(100vh - 132px);'
      }
      return css
    },
    alle_erforderlichen_dokumente_vorhanden () {
      const jahr = parseInt(this.$route.params.jahr)
      for( let b of this.anlage_v_bezeichnungen_for_year(jahr))
      {
        if( (jahr === this.anlage_v_jahre[this.anlage_v_jahre.length - 1] && b.anlage_v_erstes_jahr) || (jahr > this.anlage_v_jahre[this.anlage_v_jahre.length - 1] && b.anlage_v_folgejahr))
        {
          if( this.suche_vorhandene_dokumente_nach_bezeichnung(b.bezeichnung, jahr).length === 0)
          {
            return false
          }
        }
      }
      return true
    },
    anzahl_neue_nachrichten () {
      if( !this.nachrichten)
      {
        return 0
      }
      if( this.nachrichten.length === 0)
      {
        return 0
      }
      let counter = 0
      for( let nachricht of this.nachrichten)
      {
        if( !nachricht.gelesen_datetime)
        {
          counter += 1
        }
      }
      return counter
    },
    anlage_v_jahre () {
      let jahre = []
      if( !this.vertrag || !this.vertrag.wohnungen || !this.vertrag.wohnungen[0] || !this.vertrag.wohnungen[0].immobilie.baubeginn)
      {
        return false
      }
      let baubeginn = this.vertrag.wohnungen[0].immobilie.baubeginn
      // let fertigstellung = this.vertrag.wohnungen[0].immobilie.fertigstellung
      const aktuelles_jahr = (new Date()).getFullYear()
      for( let j = aktuelles_jahr - 1; j >= baubeginn; j--)
      {
        jahre.push(j)
      }
      return jahre
    },
    vertrag_abgeschlossen_date () {
      if( !this.vertrag || !this.vertrag.vertrag_abgeschlossen || this.vertrag.vertrag_abgeschlossen === '')
      {
        return false
      }
      return new Date(Date.parse(this.vertrag.vertrag_abgeschlossen))
    },
    vertrag () {
      if( this.vertraege && this.$route && this.$route.params && this.$route.params.vertrag_id)
      {
        return this.vertraege[this.$route.params.vertrag_id]
      }
      return false
    },
    immobilien () {
      if( !this.vertraege)
      {
        return []
      }
      let arr = Object.keys(this.vertraege).filter(function (id) { return this.vertraege[id].product === 'Immobilie' }.bind(this))
      arr = arr.sort(function( a, b){ 
        return this.vertraege[a].vertrag_abgeschlossen < this.vertraege[b].vertrag_abgeschlossen ? 1 : -1
      }.bind(this))
      return arr
    },
    immobilen_anhaenge_fuer_anlage_v () {
      if( !this.vertrag || !this.vertrag.wohnungen || !this.vertrag.wohnungen[0] || !this.vertrag.wohnungen[0].immobilie || !this.vertrag.wohnungen[0].immobilie.bilder || this.vertrag.wohnungen[0].immobilie.bilder.length === 0)
      {
        return []
      }
      const bilder = this.vertrag.wohnungen[0].immobilie.bilder
      let arr = []
      for( const bild of bilder)
      {
        if( bild.anlagev === true)
        {
          arr.push(bild)
        }
      }
      return arr
    },
    sparvertraege () {
      if( !this.vertraege)
      {
        return []
      }
      let arr = Object.keys(this.vertraege).filter(function (id) { return this.vertraege[id].product === 'Auvesta' }.bind(this))
      arr = arr.sort(function( a, b){ 
        return this.vertraege[a].vertrag_abgeschlossen < this.vertraege[b].vertrag_abgeschlossen ? 1 : -1
      }.bind(this))
      return arr
    },
    versicherungen () {
      if( !this.vertraege)
      {
        return []
      }
      let arr = Object.keys(this.vertraege).filter(function (id) { return this.vertraege[id].product === 'Opti5' || this.vertraege[id].product === 'Multi Rente'}.bind(this))
      arr = arr.sort(function( a, b){ 
        return this.vertraege[a].vertrag_abgeschlossen < this.vertraege[b].vertrag_abgeschlossen ? 1 : -1
      }.bind(this))
      return arr
    },
    vorheriges_bild()
    {
      if( !this.aktuelle_wohnung)
      {
        return false
      }
      if( !this.last_image)
      {
        return false
      }

      let arr = this.bilder_fuer_wohnung_mit_mimetype_image(this.aktuelle_wohnung)
      arr = arr.concat(this.bilder_fuer_immobilie_mit_mimetype_image(this.aktuelle_wohnung.immobilie))

      let vorheriges_bild = false
      for( let bild of arr)
      {
        if( (this.base_url + bild.url) === this.last_image)
        {
          break
        }
        vorheriges_bild = bild

      }
      return vorheriges_bild
    },
    naechstes_bild()
    {
      if( !this.aktuelle_wohnung)
      {
        return false
      }
      if( !this.last_image)
      {
        return false
      }

      let arr = this.bilder_fuer_wohnung_mit_mimetype_image(this.aktuelle_wohnung)
      arr = arr.concat(this.bilder_fuer_immobilie_mit_mimetype_image(this.aktuelle_wohnung.immobilie))

      let take_next = false
      for( let bild of arr)
      {
        if( take_next)
        {
          return bild
        }
        if( (this.base_url + bild.url) === this.last_image)
        {
          take_next = true
        }
      }
      return false
    }
  },
  methods: {
    remove_pdf_ending(filename)
    {
      if( !filename)
      {
        return ''
      }
      if( filename.match(/.*\.pdf/))
      {
        return filename.substring(0, filename.length - 4)
      }
      return filename
    },
    call_show_pdf(url)
    {
      this.last_scroll_position= window.pageYOffset || document.documentElement.scrollTop
      this.show_pdf = url
    },
    call_restore_after_show_pdf()
    {
      this.show_pdf = false
      setTimeout(function() {
        window.scrollTo(0, this.last_scroll_position)
      }.bind(this), 100)
    },
    zeige_bild(src, is_first_call)
    {
      if( is_first_call)
      {
        this.last_scroll_position= window.pageYOffset || document.documentElement.scrollTop
      }
      this.last_image = src
      this.show_image = src
    },
    call_restore_after_show_image()
    {
      this.show_image = false
      setTimeout(function() {
        window.scrollTo(0, this.last_scroll_position)
      }.bind(this), 100)
    },
    grundrissbild_fuer_wohnung(wohnung)
    {
      for( let bild of wohnung.bilder)
      {
        if( bild.grundriss)
        {
          return bild
        }
      }
      return false
    },
    zeige_naechstes_bild()
    {
      if( this.naechstes_bild)
      {
        this.show_image = 'static/img/loading.gif'
        this.zeige_bild(this.base_url + this.naechstes_bild.url, false)
      }
    },
    zeige_vorheriges_bild()
    {
      if( this.vorheriges_bild)
      {
        this.show_image = 'static/img/loading.gif'
        this.zeige_bild(this.base_url + this.vorheriges_bild.url, false)
      }
    },
    bilder_fuer_wohnung_mit_mimetype_image(wohnung)
    {
      let arr = []
      for( let bild of wohnung.bilder)
      {
        if( bild && bild.mime_type && bild.mime_type.startsWith('image/'))
        {
          arr.push(bild)
        }
      }
      arr = arr.sort( function( a, b) {
        return a.position < b.position ? -1 : 1
      })
      return arr
    },
    bilder_fuer_immobilie_mit_mimetype_image(immobilie)
    {
      let arr = []
      for( let bild of immobilie.bilder)
      {
        if( bild && bild.mime_type && bild.mime_type.startsWith('image/'))
        {
          arr.push(bild)
        }
      }
      arr = arr.sort( function( a, b) {
        return a.position < b.position ? -1 : 1
      })
      return arr
    },
    appExitOnAndroid()
    {
      navigator.app.exitApp();
    },
    anlage_v_bezeichnungen_for_year(jahr)
    {
      jahr = parseInt(jahr)

      // console.log('anlage_v_bezeichnungen_for_year')
      // console.log(jahr)
      if( !this.vertrag || !this.vertrag.wohnungen || !this.vertrag.wohnungen[0] || !this.vertrag.wohnungen[0].immobilie)
      {
        return []
      }
      let immobilie_baubeginn = parseInt(this.vertrag.wohnungen[0].immobilie.baubeginn)
      let immobilie_fertigstellung = parseInt(this.vertrag.wohnungen[0].immobilie.fertigstellung)
      // console.log('baubeginn: ' + immobilie_baubeginn)
      // console.log('fertigstellung: ' + immobilie_fertigstellung)
      
      let arr = []
      for( let avb of this.anlage_v_bezeichnungen)
      {
        // console.log(avb.bezeichnung)
        // console.log('anlage_v_baujahr: ' + avb.anlage_v_baujahr)
        // console.log('anlage_v_folgejahr: ' + avb.anlage_v_folgejahr)

        if( avb.anlage_v_erstes_jahr)
        {
          if( jahr === immobilie_baubeginn || jahr < immobilie_fertigstellung && jahr > immobilie_baubeginn)
          {
            arr.push(avb) // genau erstes jahr
            continue
          }
        }
        if( avb.anlage_v_folgejahr)
        {
          if( jahr >= immobilie_fertigstellung)
          {
            arr.push(avb) // vermietungsjahr
            continue
          }
        }
      }
      return arr
    },
    upload_button_pressed( b)
    {
      this.dokumenten_bezeichnung_id = b.id
      document.getElementById('file_input_id').click()
    },
    delete_upload( dokument) {
      if( !confirm('Dokument ' + this.remove_pdf_ending(dokument.filename) + ' löschen?'))
      {
        return
      }
      if( !dokument || !dokument.id)
      {
        return
      }

      let formData = new FormData()
      formData.append('attachment_id', dokument.id)
      formData.append('vertrag_id', this.vertrag.vertrag_id)
      formData.append('token', this.secret_token)
      this.$http.post( this.ajax_url + 'delete_upload.json', formData, { emulateJSON: true, withCredentials: false})
        .then(function (response) {
          if( response.data.success)
          {
            this.vertrag.dokumente = []
            for( let dokument of response.data.dokumente)
            {
              this.vertrag.dokumente.push(dokument)
            }

          }
        }.bind(this))
    },
    datei_ausgewaehlt(e) {
      if( !this.dokumenten_bezeichnung_id || this.dokumenten_bezeichnung_id < 0)
      {
        return
      }

      var files = e.target.files || e.dataTransfer.files
      if( !files.length || !files[0])
      {
        return
      }

      let formData = new FormData()
      formData.append('upload', files[0])
      formData.append('vertrag_id', this.vertrag.vertrag_id)
      formData.append('dokumenten_bezeichnung_id', this.dokumenten_bezeichnung_id)
      formData.append('veranlagungsjahr', this.$route.params.jahr)
      formData.append('token', this.secret_token)
      this.render_uploadform = false
      this.warte_auf_upload = true
      this.$http.post( this.ajax_url + 'upload.json', formData, { emulateJSON: true, withCredentials: false})
        .then(function (response) {

          this.render_uploadform = true
          this.warte_auf_upload = false

          if( response.data.success)
          {
            for( let dokument of response.data.dokumente)
            {
              this.vertrag.dokumente.push(dokument)
            }
          }
        }.bind(this))
        .catch( () => { this.warte_auf_upload = false } )
    },
    suche_vorhandene_dokumente_nach_bezeichnung(bez, jahr)
    {
      let ret = []
      if( !this.vertrag)
      {
        return []
      }
      jahr = parseInt(jahr)
      for( let d of this.vertrag.dokumente)
      {
        if( d.filename.toLowerCase().startsWith(bez.toLowerCase()) || d.filename.toLowerCase().includes('-' + bez.toLowerCase()) )
        {
          if( !d.veranlagungsjahr || d.veranlagungsjahr === jahr)
          {
            ret.push(d)
          }
        }
      }
      return ret
    },
    anlage_v_href(jahr) {
      return '/vertrag/' + this.vertrag.vertrag_id + '/anlage-v/' + jahr
    },
    dokumente(ist_finanzierung) {
      if( !this.vertrag)
      {
        return []
      }
      if( !this.vertrag.dokumente)
      {
        return []
      }
      let ret = []
      for( let d of this.vertrag.dokumente)
      {
        if( d.ist_finanzierung === ist_finanzierung)
        {
          ret.push(d)
        }
      }
      ret = ret.sort(function(a,b){
        return a.filename < b.filename ? -1 : 1
      })
      return ret
    },
    google_maps_url_fullwidth(google_maps_url)
    {
      if( !google_maps_url || google_maps_url === '')
      {
        return ''
      }
      let g = google_maps_url.replace( new RegExp('width="\\d+"', 'gm'), 'width="100%"')
      return g
    },
    beantrage_anlage_v()
    {
      let vertrag_id = this.vertrag.vertrag_id
      this.$http.post( this.ajax_url + 'kontaktanfrage.json', { token: this.secret_token, kontaktanfragetext: 'Beantragung der Anlage-V für das VJ ' + this.$route.params.jahr, titel: 'Beantragung Anlage-V', anlage_v_antrag: this.$route.params.jahr, vertrag_id: vertrag_id }, {emulateJSON: true, withCredentials: false})
        .then(function (response) {
            if( response.data.success)
            {
              this.anlage_v_wurde_beantragt = vertrag_id + ':' + this.$route.params.jahr
            }
          }.bind(this)
        )
        .catch( (error) => { console.log(error); this.kontaktanfragewirdabgeschickt = false } )
    },
    sende_kontaktanfrage()
    {
      this.kontaktanfragewirdabgeschickt = true
      this.$http.post( this.ajax_url + 'kontaktanfrage.json', { token: this.secret_token, kontaktanfragetext: this.kontaktanfragetext, titel: 'Kontaktanfrage' }, {emulateJSON: true, withCredentials: false})
        .then(function (response) {
            if( response.data.success)
            {
              this.kontaktanfrageabgeschickt = new Date()
            }
            this.kontaktanfragewirdabgeschickt = false
          }.bind(this)
        )
        .catch( (error) => { console.log(error); this.kontaktanfragewirdabgeschickt = false } )
    },
    sende_empfehlunganfrage()
    {
      this.empfehlunganfragewirdabgeschickt = true
      this.$http.post( this.ajax_url + 'kontaktanfrage.json', { token: this.secret_token, kontaktanfragetext: this.empfehlunganfragetext, titel: 'Empfehlung'}, {emulateJSON: true, withCredentials: false})
        .then(function (response) {
            if( response.data.success)
            {
              this.empfehlunganfrageabgeschickt = new Date()
            }
            this.empfehlunganfragewirdabgeschickt = false
          }.bind(this)
        )
        .catch( (error) => { console.log(error); this.empfehlunganfragewirdabgeschickt = false } )
    },
    mobilemenuetoggle()
    {
      this.mobilemenue = !this.mobilemenue
    },
    format_euro(zahl)
    {
      return helper.methods.format_euro(zahl)
    },
    is_cordova()
    {
      return window.cordova
    },
    is_ios()
    {
      return this.is_cordova() && window.cordova.platformId === 'ios'
    },
    is_android()
    {
      return this.is_cordova() && window.cordova.platformId === 'android'
    },
    check_session()
    {
      if( !this.mandanten_id)
      {
        const local_storage_token = localStorage.getItem('token')
        if( local_storage_token && local_storage_token !== '')
        {
          this.secret_token = local_storage_token
          sha256(this, this.secret_token)
          // this.secret_token_sha256 = await sha256(this.secret_token)
          this.login()
        }
        else
        {
          if( this.$route.name !== 'Login')
          {
            router.replace('/login')
          }
        }
      }
      else
      {
        if( this.$route.name === 'Login')
        {
          router.replace('/')
        }
        this.checkNotificationPermission(false)
        this.registerFirebaseHandlers()
      }
    },
    login() 
    {
      this.mandanten_id = false
      this.mandant = false
      this.vertraege = false
      this.login_fehlermeldung = false
      this.anlage_v_antraege_by_vertrag_und_jahr = {}

      let data = {}
      data['useragent'] = navigator.userAgent

      let action = ''

      if( this.secret_token && this.secret_token !== '' && this.secret_token !== undefined && this.secret_token !== 'undefined')
      {
        action = 'continue_session'
        data['token'] = this.secret_token
      }
      else
      {
        if( !this.loginname || this.loginname === '' || !this.password || this.password === '')
        {
          this.login_fehlermeldung = 'Benutzername und Passwort muss ausgefüllt werden.'
          return
        }
        action = 'create_session'
        data['loginname'] = this.loginname
        data['password'] = this.password
      }

      this.warte_auf_login = true
      this.$http.post( this.ajax_url + action + '.json', data, {emulateJSON: true, withCredentials: false})
        .then(function (response) {

          this.warte_auf_login = false
          if( response.data.success)
          {
            if( action === 'create_session' && this.secret_token !== response.data.token)
            {
              localStorage.setItem('token', response.data.token)
              this.secret_token = response.data.token
              // this.secret_token_sha256 = await sha256(this.secret_token)
              sha256(this, this.secret_token)
            }

            this.mandant = response.data.mandant
            this.vertraege = response.data.vertraege
            this.nachrichten = response.data.nachrichten.sort(function( a, b) { return a.id > b.id ? -1 : 1 })
            this.anlage_v_bezeichnungen = response.data.anlage_v_bezeichnungen
            this.anlage_v_antraege_by_vertrag_und_jahr = response.data.anlage_v_antraege
            this.mandanten_id = this.mandant.mandant_id
            this.login_fehlermeldung = false
            this.init_kontaktanfragetext()
            this.init_empfehlunganfragetext()

            this.checkNotificationPermission(false)
            this.registerFirebaseHandlers()

            if( this.$route.name === 'Login')
            {

              if(this.anzahl_neue_nachrichten > 0)
              {
                router.replace('/nachrichten')
              }
              else
              {
                router.replace('/')
              }
            }
          }
          else
          {
            if( action === 'create_session')
            {
              this.login_fehlermeldung = 'Fehler bei Login. Bitte überprüfen Sie Benutzername und Passwort.'
            }
            else
            {
              this.login_fehlermeldung = 'App-Token ist ungültig. Bitte melden Sie sich mit Benutzername und Passwort an.'
            }
          }
        }.bind(this))
        .catch( (error) => { this.warte_auf_login = false; console.log(error); this.login_fehlermeldung = 'Fehler bei Verbindungsaufbau mit Server. Bitte überprüfen Sie die Internetverbindung.' })
    },
    init_kontaktanfragetext()
    {
      this.kontaktanfragetext = 'Sehr geehrte Damen und Herren,\n\nich habe folgende Frage: \n\n\n\nmit freundlichen Grüssen\n\n' + this.mandant.mandant_vorname + ' ' + this.mandant.mandant_nachname
    },
    init_empfehlunganfragetext()
    {
      this.empfehlunganfragetext = 'Sehr geehrte Damen und Herren,\n\nich habe folgende Empfehlung: \n\n\n\nmit freundlichen Grüssen\n\n' + this.mandant.mandant_vorname + ' ' + this.mandant.mandant_nachname
    },
    logout()
    {
      if( window.confirm('Sollen die Zugangsdaten gelöscht werden? Beim nächsten Start der aktiv forum app benötigen Sie ihre Zugangsdaten um sich anzumelden.'))
      {
        this.mandanten_id = false
        this.loginname = ''
        this.password = ''
        this.secret_token = ''
        this.secret_token_sha256 = ''
        localStorage.setItem('token', '')
        router.replace('/login')
      }
    },
    checkNotificationPermission( requested ) 
    {
      if( this.fcmtokenrefreshed)
      {
        return
      }
      if( !window.FirebasePlugin)
      {
        return
      }

      window.FirebasePlugin.hasPermission( function( hasPermission)
        {
          if( hasPermission)
          {
            console.log("Remote notifications permission granted")
            this.getFCMToken();
          }
          else if( !requested)
          {
            console.log("Requesting remote notifications permission")
            window.FirebasePlugin.grantPermission(this.checkNotificationPermission.bind(this, true))
          }
          else
          {
            console.log("Notifications won't be shown as permission is denied")
          }
        }.bind(this))
    },
    getFCMToken()
    {
      if( !window.FirebasePlugin)
      {
        return
      }
      window.FirebasePlugin.getToken( function( fcmtoken)
        {
          console.log("Got FCM token: " + fcmtoken)
          this.$http.post( this.ajax_url + 'fcmtoken.json', { token: this.secret_token, fcmtoken: fcmtoken}, {emulateJSON: true, withCredentials: false}).then(function (response) {
              if( response.data.success)
              {
                console.log(response.data.msg)
                this.fcmtokenrefreshed = true
              }
            }.bind(this)
            )
        }.bind(this), 
        function( error) {
          console.log("Failed to get FCM token")
          console.log(error)
        })
    },
    registerFirebaseHandlers()
    {
      if( this.fcmtokenrefreshed)
      {
        return
      }
      if( !window.FirebasePlugin)
      {
        return
      }

      window.FirebasePlugin.onMessageReceived( function( message) 
        {
          try
          {
            console.log("onMessageReceived")
            console.dir(message)
            if( message.messageType === "notification" )
            {
              this.handleNotificationMessage(message)
            }
            else
            {
              this.handleDataMessage(message)
            }
          }
          catch( e )
          {
            console.log("Exception in onMessageReceived callback: " + e.message)
          }
        }.bind(this), 
        function(error) 
        {
          console.log("Failed receiving FirebasePlugin message")
          console.log(error)
        })

      window.FirebasePlugin.onTokenRefresh( function(token)
        {
          console.log("Token refreshed: " + token)
        }, 
        function(error) 
        {
        console.log("Failed to refresh token")
        console.log(error)
      })
    },
    handleNotificationMessage( message)
    {
      console.log('handleNotificationMessage: ')
      console.log(message)
      this.login()
    },
    handleDataMessage( message)
    {
      console.log('handleDataMessage: ')
      console.log(message)
      this.login()
    },
    initIOS()
    {
      if( !window.FirebasePlugin)
      {
        return
      }

      window.FirebasePlugin.onApnsTokenReceived( function( token)
        {
          console.log("APNS token received: " + token)
        }, 
        function(error) 
        {
          console.log("Failed to receive APNS token");
          console.log(error);
        }
      )

      window.FirebasePlugin.registerInstallationIdChangeListener( function( installationId )
        {
          console.log("Installation ID changed - new ID: " + installationId);
        }
      )
    },
    initAndroid()
    {

      // Define custom  channel - all keys are except 'id' are optional.
      var customChannel  = {
        // channel ID - must be unique per app package
        id: "aktiv_forum",

        // Channel name. Default: empty string
        name: "aktiv forum",

        //The sound to play once a push comes. Default value: 'default'
        //Values allowed:
        //'default' - plays the default notification sound
        //'ringtone' - plays the currently set ringtone
        //filename - the filename of the sound file located in '/res/raw' without file extension (mysound.mp3 -> mysound)
        sound: "default",

        //Vibrate on new notification. Default value: true
        //Possible values:
        //Boolean - vibrate or not
        //Array - vibration pattern - e.g. [500, 200, 500] - milliseconds vibrate, milliseconds pause, vibrate, pause, etc.
        vibration: [300, 200, 300],

        // Whether to blink the LED
        light: true,

        //LED color in ARGB format - this example BLUE color. If set to -1, light color will be default. Default value: -1.
        lightColor: "0xFF007DC5",

        //Importance - integer from 0 to 4. Default value: 3
        //0 - none - no sound, does not show in the shade
        //1 - min - no sound, only shows in the shade, below the fold
        //2 - low - no sound, shows in the shade, and potentially in the status bar
        //3 - default - shows everywhere, makes noise, but does not visually intrude
        //4 - high - shows everywhere, makes noise and peeks
        importance: 4,

        //Show badge over app icon when non handled pushes are present. Default value: true
        badge: true,

        //Show message on locked screen. Default value: 1
        //Possible values (default 1):
        //-1 - secret - Do not reveal any part of the notification on a secure lockscreen.
        //0 - private - Show the notification on all lockscreens, but conceal sensitive or private information on secure lockscreens.
        //1 - public - Show the notification in its entirety on all lockscreens.
        visibility: 1
      }

      window.FirebasePlugin.createChannel( customChannel,
        function() {
            console.log("Created custom channel: " + customChannel.id)
            window.FirebasePlugin.listChannels(
              function(channels) 
              {
                if( typeof channels == "undefined" )
                {
                  return
                }
                for( var i = 0; i < channels.length; i++) 
                {
                  console.log("Channel id=" + channels[i].id + "; name=" + channels[i].name)
                }
              },
              function(error) 
              {
                  console.log('List channels error: ' + error)
              }
            )
        },
        function(error) 
        {
          console.log("Create channel error")
          console.log(error)
        }
    )
    }
  },
  mounted() {
    this.check_session()
    if( window.cordova && window.cordova.platformId === 'ios')
    {
      this.initIOS()
    }
    if( window.cordova && window.cordova.platformId === 'android')
    {
      this.initAndroid()
    }
  }
}
</script>
<style>
</style>
